import { IntervalEndingEnum } from '@/services/models/enums'
import { IntervalSide } from '@/types/variable'

export function defineIntervalEndingSymbol(
  ending: IntervalEndingEnum,
  side: IntervalSide,
) {
  switch (side.concat('-', ending)) {
    case `lower-${IntervalEndingEnum.Closed}`:
      return '['
    case `lower-${IntervalEndingEnum.Open}`:
      return '('
    case `upper-${IntervalEndingEnum.Closed}`:
      return ']'
    case `upper-${IntervalEndingEnum.Open}`:
      return ')'
    default:
      throw new Error('Unknown side-ending combination')
  }
}
